import Avatar from "./Avatar";
import Icon from "./icons/Icon";
import Rangliste from "./Rangliste";
import { ergebnisText, rangliste } from "../spieler";
import "./Podium.css";

/**
 * Endstand: Krone, wer gewinnt, darunter das Podest (Host, alle schauen
 * auf ein Geraet) oder die Rangliste (eigenes Handy, mit "Du").
 * eintraege: [{ key, name, score }], ich: eigener Name oder null.
 * @category spiel
 */
export function Podium({ eintraege, ich = null, farbe, alsListe = false }) {
  const liste = rangliste(eintraege);
  const { titel, zeile } = ergebnisText(eintraege, ich);
  const sieg = (e) => e.platz === 1 && e.score > 0;

  return (
    <div className="endstand">
      <div className="sieger">
        <span className="sieger-krone">
          <Icon name="krone" size={40} />
        </span>
        <h1>{titel}</h1>
        {zeile && <p>{zeile}</p>}
      </div>

      {alsListe || liste.length < 2 ? (
        <Rangliste
          farbe={farbe}
          eintraege={liste.map((e) => ({
            key: e.key ?? e.name,
            name: e.name,
            platz: e.platz,
            wert: e.score,
            sieg: sieg(e),
            ich: ich !== null && e.name === ich,
          }))}
        />
      ) : (
        <>
          <div className="podest">
            {[liste[1], liste[0], liste[2]].map(
              (e, i) =>
                e && (
                  <div key={e.key ?? e.name} className={`stufe platz-${["zwei", "eins", "drei"][i]}${sieg(e) ? " sieg" : ""}`}>
                    <Avatar name={e.name} farbe={farbe(e.name)} />
                    <span className="stufe-name">{e.name}</span>
                    <div className="stufe-block">{e.score}</div>
                  </div>
                )
            )}
          </div>
          {liste.length > 3 && (
            <Rangliste
              farbe={farbe}
              eintraege={liste.slice(3).map((e) => ({ key: e.key ?? e.name, name: e.name, platz: e.platz, wert: e.score }))}
            />
          )}
        </>
      )}
    </div>
  );
}

export default Podium;
